export enum WebhookStatus {
  Success = 'success',
  Error = 'error',
  Cancelled = 'cancelled',
}
